import { Suspense, lazy, useState } from 'react';

import { useSelector } from 'react-redux';

import ConfirmCancelPopup from 'components/Auth/SignupVerification/partials/SignUpSuccessModal/ConfirmCancelPopup';
import { CenterLoader } from 'components/loader';
import Render from 'components/render';
import {
  RenderForGlobalExchange,
  RenderForIndianExchange,
} from 'components/render/RenderByExchangeType';
import { IS_DEMO } from 'constants/constants';
import { STORAGE_KEYS } from 'constants/enums';
import useLocalStorage from 'hooks/useLocalStorage';
import { selectIsSubAccount } from 'selectors/account';
import {
  selectUserCountry,
  selectUserLoginCount,
  userAddressProofSelector,
  userIdentityProofSelector,
} from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';

const SignUpSuccessModal = lazy(
  () =>
    import(
      /* webpackChunkName: "SignUpSuccessModal" */ 'components/Auth/SignupVerification/partials/SignUpSuccessModal'
    )
);

const DeltaIndiaSignupSuccessModal = lazy(
  () =>
    import(
      /* webpackChunkName: "DeltaIndiaSignupSuccessModal" */ 'components/Auth/SignupVerification/partials/SignUpSuccessModal/DeltaIndiaSignupSuccessModal'
    )
);

const MAX_TIME_TO_DISPLAY_MODAL = 1;

const AccountCreatedGetVerifiedModal = () => {
  const [accountCreatedModalCount, setAccountCreatedModalCount] = useLocalStorage(
    STORAGE_KEYS.ACCOUNT_CREATED_MODAL_COUNT,
    0
  );

  const country = useAppSelector(selectUserCountry);

  // Modal when user is redirected to markets after successful register.
  const userAddressStatus = useAppSelector(userAddressProofSelector);
  const userIdentityStatus = useAppSelector(userIdentityProofSelector);
  const userLoginCount = useAppSelector(selectUserLoginCount);
  const [isCloseConfirmationModalOpen, setIsCloseConfirmationModalOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const isSubAccount = useSelector(selectIsSubAccount);

  const updateAccountCreatedModalCount = () => {
    setAccountCreatedModalCount(count => count + 1);
  };

  const closeRegisterModal = (e, { selectedCountry: userSelectedCountry }) => {
    setSelectedCountry(userSelectedCountry);
    updateAccountCreatedModalCount();
    setIsCloseConfirmationModalOpen(true);
  };

  const closeConfirmPopup = () => {
    setIsCloseConfirmationModalOpen(false);
  };

  const showSignupSuccessModal =
    !IS_DEMO&&
    !isSubAccount &&
    accountCreatedModalCount < MAX_TIME_TO_DISPLAY_MODAL &&
    userAddressStatus === 'pending' &&
    userIdentityStatus === 'pending' &&
    country !== 'Singapore' &&
    userLoginCount === 1;

  return (
    <>
      <Render when={showSignupSuccessModal}>
        <Suspense fallback={<CenterLoader />}>
          <RenderForGlobalExchange>
            <SignUpSuccessModal
              isOpen={showSignupSuccessModal}
              close={closeRegisterModal}
              onClickVerified={updateAccountCreatedModalCount}
            />
          </RenderForGlobalExchange>
          <RenderForIndianExchange>
            <DeltaIndiaSignupSuccessModal
              isOpen={showSignupSuccessModal}
              close={closeRegisterModal}
              onClickVerified={updateAccountCreatedModalCount}
            />
          </RenderForIndianExchange>
        </Suspense>
      </Render>
      <Render when={isCloseConfirmationModalOpen}>
        <ConfirmCancelPopup
          isOpen={isCloseConfirmationModalOpen}
          close={closeConfirmPopup}
          selectedCountry={selectedCountry}
        />
      </Render>
    </>
  );
};

export { AccountCreatedGetVerifiedModal };
